import { Interpretation } from "./Interpretation";


export class DatasetOption{
    date: Date;
    interpretation: Interpretation;
    dataType: string;
    exportFormat: string;
    isFullDataset: boolean;
}